<template>
	<md-card class="card-stats">
		<md-card-header class="md-card-header-icon md-card-header-blue">
			<div class="md-layout md-gutter">
				<div class="md-layout-item">
					<div class="card-icon">
						<font-awesome-icon class="md-icon" :icon="['fa', 'chart-line']" />
					</div>
					<h4 class="title">Statistiques générales</h4>
				</div>
			</div>
		</md-card-header>
		<md-card-content>
			<div class="relative" style="min-height: 200px;">
				<template v-if="!loading">
					<div class="flex items-center space-x-6 divide-x-2 mt-2 mb-5">
						<p class="text-base font-medium leading-none mb-0">Clients actifs : <span class="text-primary">{{ stats.clients }}</span></p>
						<p class="text-base font-medium leading-none mb-0 pl-6">Sites actifs : <span class="text-primary">{{ stats.sites }}</span></p>
						<p class="text-base font-medium leading-none mb-0 pl-6">Contrats actifs : <span class="text-primary">{{ stats.contracts }}</span></p>
					</div>
					<md-divider class="mb-5"></md-divider>
					<div class="mb-4">
						<p class="text-base font-medium leading-none mb-2">Interventions : <span class="text-primary">{{ stats.totalInterventions }}</span></p>
						<div class="flex items-center justify-start" v-for="intervention in stats.interventions" :key="intervention.name">
							<font-awesome-icon class="md-icon" :icon="['fa', 'cube']" />
							<p class="leading-none font-normal ml-2 mb-0">
								{{ intervention.name }} :
								<span class="text-primary font-medium">{{ intervention.total }}</span>
							</p>
						</div>
					</div>
					<md-divider class="mb-5"></md-divider>
					<div>
						<p class="text-base font-medium leading-none mb-3">Dispositifs actifs : <span class="text-primary">{{ stats.totalDevices }}</span></p>
						<div class="grid grid-cols-3 gap-4">
							<div v-for="device in stats.devices" :key="device.name" class="flex items-center justify-start">
								<img :src="`${apiUrl}/storage/uploads/device-types/${device.path}`" alt="picto" />
								<span class="leading-none font-normal ml-2">{{ device.name }} : <span class="text-primary font-medium">{{ device.total }}</span></span>
							</div>
						</div>
					</div>
				</template>
				<div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
					<div class="h-full w-full flex items-center justify-center">
						<md-progress-spinner class="md-white" md-mode="indeterminate"
						                     :md-diameter="50" :md-stroke="4"></md-progress-spinner>
					</div>
				</div>
			</div>
		</md-card-content>
	</md-card>
</template>

<script>
export default {
	name: "StatistiquesGlobal",
	props: {
		active: Boolean
	},
	data() {
		return {
			stats: {
				clients: 0,
				sites: 0,
				contracts: 0,
				totalInterventions: 0,
				interventions: [],
				totalDevices: 0,
				devices: []
			},
			apiUrl: process.env.VUE_APP_API_STORAGE_BASE_URL,
			loading: true
		}
	},
	methods: {
		async getStats() {
			this.loading = true

			const { data } = await this.$store.dispatch('stats/getGeneralStats')
			this.stats = {
				...data,
				totalInterventions: data.interventions.total,
				interventions: data.interventions.list,
				totalDevices: data.devices.total,
				devices: data.devices.list
			}

			this.loading = false
		}
	},
	mounted() {
		if(this.active) {
			this.getStats()
		}
	}
}
</script>

<style scoped lang="scss">
.card-stats {
	.md-card-content {
		.md-icon {
			margin: 0;
			max-width: 15px !important;
			min-width: 15px !important;
			font-size: 15px !important;
		}
		.grid {
			img {
				max-width: 15px;
			}
		}
	}

}
</style>
